export const SET_COMPANYS = 'Companys/set';
export const SET_COMPANYS_UPDATED = 'Companys/UpdateStatus/set';
